import styled from 'styled-components';

const Footer = styled.footer`
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 800;
`;

export default Footer;
